import { useLocation } from "react-router-dom";
import { Globe, ChevronDown } from "lucide-react";

/**
 * Matches the validated prototype: tenant-select uses a unique copyright
 * line ("© Alloy Build 2026. All rights reserved.") instead of the shared
 * "Secured by Alloy · Privacy Policy · Terms" used on every other Auth
 * screen — see pages/auth/tenant-select.html's footer vs. the other 4 pages.
 * /login uses the same copyright line per its own Figma reference.
 */
export function AuthFooter() {
  const { pathname } = useLocation();
  // The router treats a trailing slash as the same route (/login/ serves
  // /login), so normalise before matching or that URL gets the wrong copy.
  const route = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const isTenantSelect = route === "/tenant-select";
  const isLogin = route === "/login";

  return (
    <footer className="auth-footer">
      <span className="auth-footer__left">
        {isTenantSelect || isLogin ? (
          "© Alloy Build 2026. All rights reserved."
        ) : (
          <>
            Secured by Alloy · <a href="#">Privacy Policy</a> · <a href="#">Terms</a>
          </>
        )}
      </span>
      <span className="auth-lang">
        <Globe size={16} strokeWidth={1.5} color="var(--ads-text)" />
        <span className="lang-name">English</span>
        <ChevronDown size={14} strokeWidth={1.5} color="var(--ads-text)" />
      </span>
    </footer>
  );
}
